// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2zHpS","footer":"ReportModalFilter_footer__2rVgk"};